import { PendenciasModal } from '@core/components/PendenciasCobranca';
import React, { useContext } from 'react';
import { VendaContext } from '../../VendaContext';

const VendaPendenciasModal = () => {
  const [visualizarPendencias, setVisualizarPendencias] = useContext(VendaContext).visualizarPendencias;
  const [pendencias] = useContext(VendaContext).pendencias;

  const handleCancelar = () => setVisualizarPendencias(false);

  return <PendenciasModal show={visualizarPendencias} pendencias={pendencias} onClose={handleCancelar} />;
};

export default VendaPendenciasModal;
